import React, { useState } from "react";
import { Link } from "react-router-dom";

const ContactTestimonials = () => {
  const [isPaused, setIsPaused] = useState(false);

  const testimonials = [
    {
      id: 1,
      text: "Avexa Systems has simplified care delivery across hospitals and homes. The platform is intuitive, reliable, and truly improves patient outcomes.",
      name: "~ Aarav",
      // avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
    },
    {
      id: 2,
      text: "Avexa Systems delivers a seamless experience for care teams and patients alike. It’s a dependable solution built for modern healthcare needs.",
      name: "~ Ananya",
      // avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop"
    },
    {
      id: 3,
      text: "With Avexa Systems, managing care feels effortless. It bridges hospitals and home care with efficiency and confidence.",
      name: "~ Rohan",
      // avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
    },
    {
      id: 4,
      text: "Avexa Systems makes connected care simple, efficient, and reliable for both hospitals and home environments.",
      name: "~ Kavya",
      // avatar: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop"
    },
    {
      id: 5,
      text: "Avexa Systems has transformed how we approach care delivery. It’s intuitive, secure, and designed with real-world healthcare in mind.",
      name: "~ Vikram",
      // avatar: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop"
    },
  ];

  // Duplicate testimonials for seamless loop
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <div className="w-full bg-white">
      {/* Testimonials Section */}
      <div className="w-full pt-16 pb-0">
        {/* Header */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
          <h2 className="font-bold text-center mb-4">
            <span className="">What Our </span>
            <span className="secondary-text">Client Says</span>
          </h2>
          <p className="text-center  max-w-3xl mx-auto">
            Hear how our innovative approach has helped businesses achieve
            measurable growth and transformation.
          </p>
        </div>

        {/* Background Image Container with Cards Inside */}
        <div className="relative w-full" style={{ marginBottom: "-60px" }}>
          <div className="mx-auto px-8 sm:px-12 lg:px-10">
            <div
              className="w-full bg-cover bg-center bg-no-repeat rounded-2xl relative"
              style={{
                backgroundImage: `url('/assets/whoWeAre/4section.svg')`,
                height: "320px",
                zIndex: 1,
                overflow: "hidden",
              }}
            >
              {/* Testimonials Scroll - Inside background image, near bottom */}
              <div
                className="absolute left-0 right-0 overflow-hidden"
                style={{
                  bottom: "30px",
                  zIndex: 10,
                }}
              >
                <div
                  className="flex gap-6 px-6"
                  style={{
                    animation: isPaused ? "none" : "scroll 30s linear infinite",
                  }}
                  onMouseEnter={() => setIsPaused(true)}
                  onMouseLeave={() => setIsPaused(false)}
                >
                  {/* {duplicatedTestimonials.map((testimonial, index) => (
                    <div
                      key={`${testimonial.id}-${index}`}
                      className="flex-shrink-0 bg-white rounded-xl shadow-2xl p-6 w-80 transition-transform hover:scale-105 flex flex-col justify-between"
                      style={{ height: '180px' }}
                    >
                      <p className="  leading-relaxed flex-grow overflow-hidden">
                        {testimonial.text}
                      </p>
                      <div className="flex items-center gap-3">
                        <div>
                          <h4 className="font-semibold ">{testimonial.name}</h4>
                        </div>
                      </div>
                    </div>
                  ))} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section - Blue Background */}
      <div
        className="bg-light w-full px-4 relative"
        style={{
          paddingTop: "150px",
          paddingBottom: "6rem",
        }}
      >
        {/* CTA Content */}
        <div
          className="max-w-4xl mx-auto text-center relative"
          style={{ zIndex: 10 }}
        >
          <h2 className="font-bold mb-6">Join the Future of Digital Health</h2>
          <p className="  mb-10 max-w-2xl mx-auto">
            We partner with healthcare organizations to deliver intelligent,
            scalable digital solutions that transform care delivery and
            outcomes.
          </p>
          <Link to="/get-in-touch">
            <button className="btn btn-primary inline-block">Contact Us</button>
          </Link>
        </div>
      </div>

      
    </div>
  );
};

export default ContactTestimonials;
